<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <b-container class="mt-5">
      <b-row class="justify-content-center">
        <b-col cols="12" md="12" lg="12">
          <b-card v-if="!loading" class="shadow">
            <b-card-header>
              <h4 class="mb-0">Campaign Details</h4>
            </b-card-header>
            <b-card-body>
              <CampaignDetails />
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-card>
      <b-card-body>
        <ContentList/>
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-body>
        <TaskList />
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-body >
        <CostList/>
      </b-card-body>
    </b-card>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BFormRadio,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BCardText,
  BFormCheckbox,
  BCard,
  BCardBody,
  BTabs,
  BTab,
} from "bootstrap-vue";
import TaskList from '../EditCampaign/CampaingTaskList.vue'
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { required, email } from "@validations";
import CostList from '../EditCampaign/Cost.vue';
import ContentList from '../EditCampaign/Content.vue';
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";
import { FormWizard, TabContent } from "vue-form-wizard";
import { quillEditor } from "vue-quill-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import CampaignDetails from "./CampaignDetails.vue";
import PlatformPosts from "./PlatformPosts.vue";
export default {
  name: "AddCampaign",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormRadio,
    vSelect,
    quillEditor,
    flatPickr,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BCardText,
    BFormCheckbox,
    BCard,
    BCardBody,
    BTabs,
    BTab,
    FormWizard,
    TabContent,
    CampaignDetails,
    PlatformPosts,
    TaskList,
    CostList,
    ContentList
  },
  data() {
    return {
      id: this.$route.params.id,
      mainLoading: false,
      imageFiles: [],
      imagePreviews: [],
      emailtemplatelist: [],
      selectedProvider: null,
      selectedTemplateId: null,
      selectedTemplate: [],
      Selected: "A",
      smtp: [],
      Selected1: "c",
      SelectedRadio: "D", // Default to "Save as Draft"
      dateNtim: null,
      selected: [{ title: "Segment 1" }, { title: "Segment 2" }],
      content: "",
      name: "",
      budget: null,
      startDate: null,
      endDate: null,
      subject: "",
      file: null,
      selectedSegments: [],
      segmentOptions: [],
      required,
      linkedinChecked: false,
      facebookChecked: false,
      instagramChecked: false,
      isSwitchChecked: false,
      facebookContent: "",
      instagramContent: "",
      linkedinContent: "",
      finishButtonText: 'Save as Draft'
    };
  },

  computed: {
    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      loading: "loading",
    }),
    ...mapGetters("marketingModule", {
      appid: "appid",
      campaignId: "campaignId",
      posts: "posts",
      loadingMarketing: "loading",
    }),
    showSaveDraft() {
      return this.SelectedRadio === "D";
    },
    showSaveScheduled() {
      return this.SelectedRadio === "B";
    },
    showSendNow() {
      return this.SelectedRadio === "A";
    },
    today() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    ...mapActions("segmentModule", ["getSegmentsAction"]),
    ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
    ...mapActions("emailcampaign", ["addEmailCampaignAction"]),
    ...mapActions("marketingModule", [
      "getAppIdAction",
      "getPostAction",
      "removePostAction",
      "postMarketingCampaignAction",
      "getMarketingCampaignByIDAction",
      "putMarketingCampaignAction",
    ]),
    completeView() {
      this.$router.push({ name: "marketing-campaign-list" });
    },
    handleAction(action) {
      // Update the finish button text based on the action
      if (action === 'draft') {
        this.finishButtonText = 'Save as Draft';
      } else if (action === 'schedule') {
        this.finishButtonText = 'Schedule';
      } else if (action === 'sendNow') {
        this.finishButtonText = 'Send Now';
      }
    },
    handleSubmit() {
      // Handle form submission based on the finish button text
      if (this.finishButtonText === 'Save as Draft') {
        this.saveDraft();
      } else if (this.finishButtonText === 'Schedule') {
        this.saveScheduled();
      } else if (this.finishButtonText === 'Send Now') {
        this.sendNow();
      }
    },
    showImagePreview(event) {
      this.imageFiles = [...event.target.files];
      this.imagePreviews = [];

      for (let file of this.imageFiles) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.imagePreviews.push(e.target.result);
        };

        reader.readAsDataURL(file);
      }
    },
    selectTemplate() {
      this.selectedTemplate = this.emailtemplate.find(
        (template) => template.templateId === this.selectedTemplateId
      );
    },

    errordateNtime() {
      this.$swal({
        title: "Error!",
        text: " Please select a date!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async formSubmitted(status) {
      // Validate the form if status is not 'DRAFT'
      if (status !== "DRAFT") {
        const isValid = await this.$refs.formAddCampaign.validate();
        if (!isValid) {
          // Handle invalid form
          return;
        }
      }

      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Campaign is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const payload = {
        campaignId: this.id,
        name: this.campaignId.name,
        startDate: this.campaignId.startDate,
        endDate: this.campaignId.endDate,
        description: this.campaignId.description,
        subject: this.campaignId.name,
        status: status,
        templateId: this.selectedTemplateId,
        segmentId: this.selectedSegments.map((segment) => segment.value),
        campaignDrafts: [
          {
            content: this.campaignId.description,
            scheduledPublishedDate:
              status === "SCHEDULED"
                ? this.campaignId.scheduledPublishedDate
                : null,
            segmentId: this.selectedSegments.map((segment) => segment.value),
          },
        ],
        smtpSettingId: this.selectedProvider,
      };

      await this.putMarketingCampaignAction(payload)
        .then((response) => {
          loader.close();
          if (status === "SCHEDULED") {
            this.success(
              `Marketing Campaign successfully scheduled for ${this.dateNtim}!`
            );
          } else {
            this.success("Marketing Campaign Updated!");
          }

          this.$router.push({ name: "marketing-campaign-list" });
        })
        .catch((ex) => {
          loader.close();
          this.error(ex.response.data);
        });
    },

    saveDraft() {
      this.formSubmitted("DRAFT");
    },
    success(message) {
      this.$swal({
        title: "Marketing Campaign Added!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    saveScheduled() {
      if (this.dateNtim === null) {
        this.errordateNtime();
        return;
      }

      if (this.SelectedRadio === "B" && this.dateNtim) {
        this.formSubmitted("SCHEDULED");
      } else {
        this.formSubmitted("DRAFT");
      }
    },

    sendNow() {
      if (this.SelectedRadio === "A") {
        this.formSubmitted("COMPLETED");
      }
    },

    async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },
  },

  async mounted() {
    this.facebookToken = this.$route.query.access_token;
    this.mainLoading = true;
    let loader = this.$swal({
        title: "Loading Data...",
        text: "Please wait while the data is being fetched.",
        didOpen: () => {
            this.$swal.showLoading();
        },
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
    });
    try {
      await this.getMarketingCampaignByIDAction(this.id);

      await this.getEmailTemplateListAction().then(() => {
        this.emailtemplatelist = this.emailtemplate.map((template) => ({
          value: template.templateId,
          text: `${template.name}`,
        }));
      });

      await this.getSMPT();

      await this.getSegmentsAction().then(() => {
        this.segmentOptions = this.segments.map((segment) => ({
          value: segment.segmentId,
          itemTitle: `${segment.name}`,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.mainLoading = false;
      this.$swal.close();
    }
  },
  watch: {
    startDate(newDate) {
      if (
        newDate &&
        this.endDate &&
        new Date(this.endDate) < new Date(newDate)
      ) {
        this.endDate = null; // Clear endDate if it is earlier than startDate
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
</style>
